import { Component, OnInit } from '@angular/core';
import { NgxDrpOptions, PresetItem, Range } from 'ngx-mat-daterange-picker';
import { Package } from '../models/package';
import { AccountService } from '../services/account/account.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { PaymentService } from '../services/payment/payment.service';
import { Account } from '../models/account';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { UserService } from '../services/user/user.service';

@Component({
  selector: 'app-offline-payment',
  templateUrl: './offline-payment.component.html',
  styleUrls: ['./offline-payment.component.css']
})
export class OfflinePaymentComponent implements OnInit {

  today = null;
  customDateFormat = "";
  range: Range = { fromDate : null, toDate: null };
  offlinePayments = [];
  public accounts: Account[];
  public packages: Package[];
  totalRecords: number = 0;
  
  private searchTerms = new Subject<any[]>();  // Subject to emit search terms
  results: any[] = [];  // Store search results
  offlinePaymentObj = {
    accountId : null,
    pkgId : null,
    transactionMode : '',
    transactionId : '',
    amount : 0,
    quantity : 1,
    dateOfPayment : null,
    currency: '',
  };
  rows = 10;
  public paging = {currentPage:  0};
  addNewOfflinePayment : boolean = false; 
  viewMode : string = 'list';
  constructor(public paymentService: PaymentService, public foruscareService : ForuscareService,public userService: UserService,public accountService: AccountService) { 
    this.setupSearch();
  }

  setAmount() {
    for (let packageItem of this.packages) {
      if( packageItem.id == this.offlinePaymentObj.pkgId ) {
        this.offlinePaymentObj.amount = packageItem.price;
        this.offlinePaymentObj.currency = packageItem.currency;
        break;
      }
    }
  }

  getAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            this.accounts = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  getPackages() {
    this.packages = [];
    this.paymentService.getAllPrepaidPackages()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            this.packages = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }
  
  downloadXLS():void{
    this.paymentService.exportOfflineReportXLS({'startDate' : this.range.fromDate+ ' 00:00:00' , 'endDate' : this.range.toDate+ ' 00:00:00'})
    .subscribe(response => {
      if( response.status == 200 ) {
        let blob = new Blob([response.body], { type: 'application/octet-stream'});
        var link = document.createElement('a');
        link.style.display = "none";
        link.href = window.URL.createObjectURL(blob);
        link.download = 'offline_payment_report.xlsx';
        link.click();
      } else{
          this.foruscareService.showNotification("File download failed","danger");
      }
    });
  }

  resetOfflinePaymentForm(){
    this.offlinePaymentObj = {
      accountId : null,
      pkgId : null,
      transactionMode : '',
      transactionId : '',
      amount : 0,
      quantity : 1,
      dateOfPayment : null,
      currency: ''
    }
  }

  clearDateFilter() {
    this.range = { fromDate : null, toDate: null };
    this.paging.currentPage = 0;
    this.getOfflinePayments(0);
  }
  getFilteredOfflinePayments() {
    this.offlinePayments = [];
    let offset = 0;
    let count = 10;
    this.paging.currentPage = 0;
    this.paymentService.fetchDateWiseFilteredOfflinePayments({'startDate' : this.range.fromDate?this.range.fromDate+ ' 00:00:00': this.range.fromDate , 'endDate' : this.range.toDate ? this.range.toDate+ ' 00:00:00': this.range.toDate},  offset, count, this.searchData.term, this.searchData.searchby)
        .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            this.offlinePayments = response.data.response;
            this.totalRecords = response.data.totalCount;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
    }); 
  }
  offset = 0;
  onPageChange(event) {
    this.offset = event.first;
    this.rows = event.rows;
    this.paging.currentPage = event.first; 
    this.getOfflinePayments(this.offset);
  }

  getOfflinePayments(offset) {
    let count = 10;
    this.offlinePayments = [];
    this.paymentService.fetchDateWiseFilteredOfflinePayments({'startDate' : this.range.fromDate?this.range.fromDate+ ' 00:00:00': this.range.fromDate , 'endDate' : this.range.toDate ? this.range.toDate+ ' 00:00:00': this.range.toDate}, offset, count,  this.searchData.term, this.searchData.searchby)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            this.offlinePayments = response.data.response;
            this.totalRecords = response.data.totalCount;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  saveOfflinePayment() {
    this.offlinePaymentObj.dateOfPayment = this.offlinePaymentObj.dateOfPayment.split('T')[0];
    this.paymentService.saveOfflinePayment(this.offlinePaymentObj)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == "SUCCESS") {
          this.foruscareService.showNotification("Offline Payment record created successfully", "success");
          this.addNewOfflinePayment = false;
          this.offset = 0;
          this.offlinePayments = [];
          this.paging.currentPage = 0;
          this.getOfflinePayments(0);
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  toggleDiv(type) {
    this.addNewOfflinePayment = !this.addNewOfflinePayment;
    if (type == "new") {
      this.resetOfflinePaymentForm();
      // this.packageDetails = new Package();
      // this.getWorkFlowByAccountId(null);
      this.viewMode = "new";
    }
    if (type == "list") {
      this.viewMode = "list";
      this.getOfflinePayments(0);
    }
  }

  ngOnInit() {
    this.customDateFormat = this.foruscareService.getDateFormat();
    // this.getOfflinePayments(0);
    this.getAccounts();
    this.getPackages();
    this.today = new Date().toJSON().split('T')[0];
  }
  setupSearch(): void {
    this.searchTerms.pipe(
      debounceTime(300),                // Wait for 300ms after the user stops typing{'startDate' : this.date.fromDate , 'endDate' : this.date.toDate}
      distinctUntilChanged(),           // Only call the API if the term has changed
      switchMap((term: any) => this.paymentService.fetchDateWiseFilteredOfflinePayments({'startDate' : null , 'endDate' : null}, this.offset, 10,  term[0],term[1]))  // Switch to the new search term
    ).subscribe(response => {
        if (response.data != null && response.data.response.length > 0) {
          this.offlinePayments = response.data.response;
          this.totalRecords = response.data.totalCount;
        }else{
          this.offlinePayments = [];
        }
            // Update the results after the API call
    });
  }

  searchData = {
    term:'',
    searchby:''
  }

  // Method triggered when typing in the search box
  onSearch(term: string, searchby:string): void {
    this.offset = 0;
    this.offlinePayments = [];
    this.paging.currentPage = 0;
    this.searchTerms.next([term,searchby]);  // Push the search term into the observable stream
    if(term && term.length > 0){
      this.searchData = {
        term:term,
        searchby:searchby
      }
    }
    else{
      this.searchData = {
        term:null,
        searchby:null
      }
    }
     
  }


}
